const host = "https://api.al-bashaar.com/";
// const host = "http://172.16.20.254:5000/";
export default host;